import type { Action, ThunkAction } from '@reduxjs/toolkit'
import { makeStore } from './utils/makeStore'
// import debounce from 'debounce'
// import { loadState, saveState } from './utils/storage'
import { rootReducer } from './rootReducer'

// Infer the `RootState` type from the root reducer
export type AppState = ReturnType<typeof rootReducer>

export const appStore = makeStore<AppState>(rootReducer)

// Infer the type of `store`
export type AppStore = typeof appStore
// Infer the `AppDispatch` type from the store itself
export type AppDispatch = AppStore['dispatch']
export type AppThunk<ThunkReturnType = void> = ThunkAction<ThunkReturnType, AppState, unknown, Action>

// appStore.subscribe(
// we use debounce to save the state once each 800ms
// for better performances in case multiple changes occur in a short time
// debounce(() => {
// 	saveState('propai', appStore.getState())
// }, 800),
// )
